import React from "react";
import { PortalDocumentResult, portalKudeUrl } from "../../api/public-portal";

interface Props {
  results: PortalDocumentResult[];
}

const ResultsList: React.FC<Props> = ({ results }) => {
  if (results.length === 0) {
    return (
      <div style={{ padding: 24, textAlign: "center", color: "var(--theme-muted)" }}>
        Sin resultados para la búsqueda.
      </div>
    );
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "0.95rem",
        }}
      >
        <thead>
          <tr style={{ background: "var(--theme-surface-raised)", textAlign: "left" }}>
            <th style={cellStyle}>Tipo</th>
            <th style={cellStyle}>Fecha</th>
            <th style={cellStyle}>Número</th>
            <th style={cellStyle}></th>
          </tr>
        </thead>
        <tbody>
          {results.map((r) => (
            <tr
              key={`${r.type}-${r.kudeToken}`}
              style={{ borderTop: "1px solid var(--theme-border)" }}
            >
              <td style={cellStyle}>{r.typeLabel}</td>
              <td style={cellStyle}>{r.date}</td>
              <td style={{ ...cellStyle, fontFamily: "monospace" }}>
                {r.formattedNumber}
              </td>
              <td style={{ ...cellStyle, textAlign: "right" }}>
                <a
                  href={portalKudeUrl(r.kudeToken)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={downloadButtonStyle}
                >
                  KUDE
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const cellStyle: React.CSSProperties = {
  padding: "10px 12px",
};

const downloadButtonStyle: React.CSSProperties = {
  display: "inline-block",
  padding: "6px 12px",
  background: "#006657",
  color: "#fff",
  borderRadius: 4,
  textDecoration: "none",
  fontWeight: 600,
  fontSize: "0.85rem",
};

export default ResultsList;
